import React from 'react';
import '../styles/ServicesSection.css';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      icon: '🐜',
      title: 'General Pest Control',
      description: 'Comprehensive treatment for ants, cockroaches, spiders, silverfish, and other common household pests.',
      features: ['Ants & Cockroaches', 'Spiders & Silverfish', 'Crickets & Earwigs', 'Preventive Maintenance'],
      color: '#e74c3c',
      popular: true
    },
    {
      id: 2,
      icon: '🪲',
      title: 'Termite Treatment',
      description: 'Advanced termite detection and elimination using proven methods to protect your property investment.',
      features: ['Termite Inspection', 'Liquid Treatments', 'Baiting Systems', 'Wood Repair'],
      color: '#8B4513',
      popular: false
    },
    {
      id: 3,
      icon: '🛏️',
      title: 'Bed Bug Extermination',
      description: 'Effective heat and chemical treatments that eliminate bed bugs at all life stages, guaranteed.',
      features: ['Heat Treatment', 'Chemical Application', 'Mattress Encasements', 'Post-Treatment Monitoring'],
      color: '#c0392b',
      popular: true
    },
    {
      id: 4,
      icon: '🐀',
      title: 'Rodent Removal',
      description: 'Humane and effective removal of mice, rats, and other rodents with long-term prevention solutions.',
      features: ['Mice & Rat Control', 'Exclusion Services', 'Trapping & Removal', 'Sanitation Services'],
      color: '#7f8c8d',
      popular: false
    },
    {
      id: 5,
      icon: '🦟',
      title: 'Mosquito Control',
      description: 'Reduce mosquito populations around your property with targeted treatments and breeding site elimination.',
      features: ['Larvicide Treatment', 'Adult Mosquito Control', 'Breeding Site Removal', 'Seasonal Protection'],
      color: '#2ecc71',
      popular: false
    },
    {
      id: 6,
      icon: '🏢',
      title: 'Commercial Services',
      description: 'Tailored pest control solutions for restaurants, hotels, offices, and commercial properties.',
      features: ['Restaurant Pest Control', 'Hotel & Hospitality', 'Office Buildings', 'Food Processing Plants'],
      color: '#3498db',
      popular: false
    },
    {
      id: 7,
      icon: '🌿',
      title: 'Eco-Friendly Treatment',
      description: 'Environmentally responsible pest control solutions that are safe for your family, pets, and the planet.',
      features: ['Green Solutions', 'Pet-Safe Products', 'Organic Treatments', 'Sustainable Practices'],
      color: '#27ae60',
      popular: false
    },
    {
      id: 8,
      icon: '🏡',
      title: 'Preventive Maintenance',
      description: 'Regular inspections and treatments to keep your property pest-free year-round with our care plans.',
      features: ['Quarterly Inspections', 'Seasonal Treatments', 'Priority Scheduling', 'Discount Programs'],
      color: '#f39c12',
      popular: false
    }
  ];

  const handleBookService = () => {
    window.location.href = 'tel:+18334936242';
  };

  const handleCallNow = () => {
    window.location.href = 'tel:+18334936242';
  };

  return (
    <section className="services-section" id="services">
      <div className="services-container">
        {/* Section Header */}
        <div className="services-header">
          <span className="services-tag">Our Services</span>
          <h2>Comprehensive Pest Control Solutions</h2>
          <p className="services-subtitle">
            We offer a full range of professional pest control services to protect your home or business
          </p>
        </div>

        {/* Services Grid */}
        <div className="services-grid">
          {services.map((service) => (
            <div className={`service-card ${service.popular ? 'popular' : ''}`} key={service.id}>
              {service.popular && (
                <div className="popular-badge">
                  <span>⭐ Most Popular</span>
                </div>
              )}
              <div className="service-icon-wrapper" style={{ backgroundColor: `${service.color}15` }}>
                <span className="service-icon" style={{ color: service.color }}>{service.icon}</span>
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, index) => (
                  <li key={index}>
                    <span className="feature-check">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="service-btn" onClick={handleBookService}>
                📞 Call Now: (833) 493-6242 →
              </button>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="services-cta-banner">
          <div className="cta-banner-content">
            <h3>Not sure which service you need?</h3>
            <p>Call us today for a free consultation and we'll help you find the right solution</p>
          </div>
          <button className="cta-banner-btn" onClick={handleCallNow}>
            📞 Call Now:+1 (833) 493-6242
          </button>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;